import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.checkliste-kopieren';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteKopierenEffects {

    ChecklisteKopieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CHECKLISTE_KOPIEREN),
        mergeMap((x: ac.PostChecklisteKopierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postChecklisteKopieren(x.checklisteRequest).pipe(
                map((result: any) => {
                    return new ac.PostChecklisteKopierenErfolgreichAction(result, x.checklisteRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostChecklisteKopierenFehlerAction(error, x.checklisteRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteCommandService);
        }
        return this.service;
    }
}
